/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  assignment?: State.Assignment
}

export namespace State {
  export interface Assignment {
    readonly error?: Error
    readonly isSubmitting?: boolean
  }

  export const INITIAL: Readonly<State> = {
    assignment: undefined,
  }

  /** Starts an assignment workflow for the fixed record selection target. */
  export function startAssignment(state: State): State {
    return {
      ...state,
      assignment: {},
    }
  }

  /** Clears the active assignment workflow. */
  export function cancelAssignment(state: State): State {
    return {
      ...state,
      assignment: undefined,
    }
  }

  /** Marks the active assignment workflow as submitting. */
  export function startSubmitting(state: State): State {
    if (!state.assignment) {
      return state
    }

    return {
      ...state,
      assignment: {
        ...state.assignment,
        error: undefined,
        isSubmitting: true,
      },
    }
  }

  /** Stores a submit failure on the active assignment workflow. */
  export function failSubmitting(state: State, error: Error): State {
    if (!state.assignment) {
      return state
    }

    return {
      ...state,
      assignment: {
        ...state.assignment,
        error,
        isSubmitting: false,
      },
    }
  }

  /** Clears the submitting state after cancellation. */
  export function cancelSubmitting(state: State): State {
    if (!state.assignment) {
      return state
    }

    return {
      ...state,
      assignment: {
        ...state.assignment,
        isSubmitting: false,
      },
    }
  }
}
